import type { ReactNode } from "react";
import { Button, OverlayArrow, Tooltip, TooltipTrigger } from "react-aria-components";
import "./tooltip.scss";
import clsx from "clsx";

export type TooltipComponentVariant = "light" | "dark";
export type TooltipComponentSize = "small" | "large";

export function TooltipComponent({
	title,
	children,
	disabled = false,
	delay = 1500,
	variant = "light",
	size = "small",
	tooltipClassName,
}: {
	title?: string;
	children?: ReactNode;
	delay?: number;
	variant?: TooltipComponentVariant;
	size?: TooltipComponentSize;
	disabled?: boolean;
	tooltipClassName?: string;
}) {
	const resolvedTooltipClassName = clsx(
		"react-aria-Tooltip",
		variant === "dark" && "tooltip--dark",
		size === "large" && "tooltip--large",
		tooltipClassName,
	);

	return (
		<TooltipTrigger delay={delay} isDisabled={disabled}>
			<Button>{children}</Button>
			{title && (
				<Tooltip className={resolvedTooltipClassName}>
					<OverlayArrow>
						{size === "large" ? (
							<svg width={20} height={10} viewBox="0 0 20 10">
								<path d="M0 0 L10 10 L20 0" />
							</svg>
						) : (
							<svg width={8} height={8} viewBox="0 0 8 8">
								<path d="M0 0 L4 4 L8 0" />
							</svg>
						)}
					</OverlayArrow>
					{title}
				</Tooltip>
			)}
		</TooltipTrigger>
	);
}
